import $ from "jquery";

const showSearchCard = {
  variables: {
    loadMore: ".blog-listing--loadmore-btn",
    loadMoreWrap: ".blog-listing--loadmore-wrap",
    listingCol: ".managePolicySection__list.in-view",
    hiddenCol: ".managePolicySection__list.in-view.d-none",
    count: 0,
  },
  methods: {
    searchContent: function () {
      $(".managePolicySection--search").on("keyup", function () {
        var searchText = $(this).val().toLowerCase();
        $(".managePolicySection__nav.initiate-search")
          .find(".managePolicySection__list")
          .each(function () {
            var titleText = $(this)
              .find(".managePolicySection__heading")
              .text()
              .toLowerCase();
            if (titleText.includes(searchText)) {
              $(this).removeClass("d-none");
              $(this).addClass("visible");
              $(this).addClass("in-view");
              $(".managePolicySection__image__imgLeft").removeClass("d-none");
              $(".managePolicySection__image__imgRight").removeClass("d-none");
            } else {
              $(this).addClass("d-none");
              $(this).removeClass("visible");
              $(this).removeClass("in-view");
              $(".managePolicySection__image__imgLeft").addClass("d-none");
              $(".managePolicySection__image__imgRight").addClass("d-none");
            }
          });

        if (
          $(".managePolicySection__nav.initiate-search").find(
            ".managePolicySection__list.visible"
          ).length == 0
        ) {
          $(".managePolicySection__nav.initiate-search").find(".no-res-found").removeClass("d-none");
        } else {
          $(".managePolicySection__nav.initiate-search").find(".no-res-found").addClass("d-none");
        }
      });
    },

    showItems: () => {
      let limit = 4;

      showSearchCard.variables.count = limit;

      $(showSearchCard.variables.loadMore).on("click", function () {
        $(this)
          .parent()
          .parent()
          .find(".managePolicySection__list.in-view")
          .slice(
            showSearchCard.variables.count,
            showSearchCard.variables.count + limit
          )
          .removeClass("d-none");
        showSearchCard.variables.count = showSearchCard.variables.count + limit;
        showSearchCard.methods.hideBtn();
      });
    },

    hideBtn: function () {
      $(".managePolicySection").each((idx, ele) => {
        if (
          $(ele).find(".managePolicySection__list.in-view.d-none").length == 0
        ) {
          $(ele).find(".blog-listing--loadmore-wrap").addClass("d-none");
        } else {
          $(ele).find(".blog-listing--loadmore-wrap").removeClass("d-none");
        }
      });
    },

    hideExtra: function () {
      let limit = 4;
      $(".managePolicySection").each((idx, ele) => {
        const length = $(ele).find(".managePolicySection__list.in-view").length;
        $(ele)
          .find(".managePolicySection__list.in-view")
          .slice(limit, length)
          .addClass("d-none");
        showSearchCard.methods.hideBtn(
          $(ele).find(".managePolicySection__list.in-view.d-none")
        );
      });
    },

    manageCardsButtonClickHandler: function () {
          $('.managePolicySection__list').on('click', function() {
             let section = $(this).closest('.managePolicySection');
              let titleText = section.find('.heading-2').text().trim();
              var obj = showSearchCard.methods.dataLayerObj($(this)
              .find('.managePolicySection__heading').text().replace(/\n/g, '').trim(),titleText);
               createDataLayer('buttonClick', obj);
          });
    },

    searchClickedHandler: function(){
         $('.managePolicySection .managePolicySection--search').on('focus', function() {
           let buttonText = $(this).val();
           let section = $(this).closest('.managePolicySection');
           let titleText = section.find('.heading-2').text().trim();
           let obj = showSearchCard.methods.dataLayerObj(buttonText,titleText);
            createDataLayer('searchClicked',obj);
         });

    },

    searchKeywordHandler: function(){
         $('.managePolicySection .managePolicySection--search').on('keyup', function() {
           let buttonText = $(this).val();
           let section = $(this).closest('.managePolicySection');
           let titleText = section.find('.heading-2').text().trim();
           let obj = showSearchCard.methods.dataLayerObj(buttonText,titleText);
            createDataLayer('enter_search_keyword',obj);
         });

    },
               dataLayerObj: function (e,el) {
                    var obj = {
                        'articleName': "",
                        'blogCategory': "",
                        'blogPageCategory': "",
                        'buttonText': e ? e : "",
                        'pageSection': el ? el : "Manage Policy Component",
                        'pageType': document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.length) === ".com/" ? "Home" : "Other Pages" : "Blog Details Page",
                        'planOption': "",
                        'productCategory': "",
                        'productName': "",
                        'question': "",
                        'source': "",
                        'searchTerm': "",
                        'videoTitle': "",
                        'bannerName': "",
                    };
                    return obj;
                },
    init: function () {
      this.searchContent();

      if (screen.width < 768) {
        this.hideExtra();
        this.hideBtn();
        this.showItems();
      }
    },
  },
};

$(document).ready(function () {
 showSearchCard.methods.manageCardsButtonClickHandler();
 showSearchCard.methods.searchClickedHandler();
 showSearchCard.methods.searchKeywordHandler();

});
$(() => {
  if ($(".managePolicySection").length > 0) {
    showSearchCard.methods.init();
  }
});
